import React from 'react'
import { Row, Col, Image, Space, Typography, Divider, Flex } from 'antd'
import { Link, NavLink } from 'react-router-dom'

const { Title, Text } = Typography
const Footer = () => {

    const data = [
        {
            id:'1',
            heading:'COMPANY',
            listdetail: [
                {
                    to:'/',
                    text:'Home'
                },
                {
                    to:'/getquote',
                    text:'Connect Pro'
                },
                {
                    to:'/findpro',
                    text:'Find a Pro'
                },
                
            ],
        },
        {
            id:'2',
            heading:'',
            listdetail: [
                {
                    to:'/privacypolicy',
                    text:'Privacy Policy'
                },
                {
                    to:'/aboutus',
                    text:'About Us'
                },
                {
                    to:'/contactus',
                    text:"Contact Us"
                }
            ],
        },
        {
            heading:'CONTACT',
            
            listdetail: [
                {
                    id:'contact',
                    text:'+38 096 272 2100',
                },
            ],
            contacts:[
                {
                    title:'Email',
                    desc: 'mail@halo-lab.com'
                },
            ]
        },
    ]

  return (
    <div className='bg-brown footer'>
        <div className='container'>
        <Row gutter={[12,12]} justify={'space-between'}>
                <Col lg={{span: 8}} md={{span: 24}} xs={{span: 24}} sm={{span: 24}}>
                    <Space direction='vertical' size={10} className='width-100'>
                        <div className='mb-1 text-center'>
                            <Link to={'/'}>
                                <img src='/assets/images/logo.png' width={150} />
                            </Link>
                        </div>
                        <Title level={5} className=''>
                        Nextdoor Pros Connect To Pro
                        </Title>
                    </Space>
                </Col>
                
                {
                    data?.map((items, index)=>
                    <Col lg={{span: 6}} xl={{span: items.id === '1' && '2' ? 5 : 4}} md={{span: 24}} xs={{span: 24}} sm={{span: 24}} key={index}>
                        <Space direction='vertical' size={15} className='list-cs'>
                            <Title className='m-0' level={5}>
                                {
                                    items?.heading
                                }
                            </Title>
                            <ul className={`ul-f m-0 ${items.id === 2 && 'count-2'}`}>
                                {
                                    items?.listdetail?.map((list,i)=>
                                        <li key={'menu'+ i}>
                                            <Flex vertical>
                                                <Flex gap={5} className='pt-1' align='center'>
                                                    {
                                                        list.id === 'contact'&&
                                                        <img src='/assets/icons/whatsapp.png' width={18} />
                                                    }
                                                    {
                                                        list.id === 'contact' ?
                                                        <NavLink to={'https://api.whatsapp.com/send?phone=447551885885'} target="_blank">
                                                            <Text className=''>
                                                                {list?.text}
                                                            </Text>
                                                        </NavLink>
                                                        :
                                                        <Link 
                                                            to={list?.to} 
                                                            className='hovera'
                                                            >
                                                            {list?.text}
                                                        </Link>
                                                    }                                                    
                                                </Flex>
                                                
                                                {/* {
                                                    list.desc &&
                                                    <Text className='text-gray hovera'>
                                                        {
                                                            list?.desc
                                                        }
                                                    </Text>
                                                } */}
                                            </Flex>
                                        </li>
                                    )
                                }
                            </ul>
                            {
                                items?.contacts?.map((con,c)=>
                                <Flex vertical gap={5} className='' key={c}>
                                    <Title className='m-0' level={5}>
                                        {con?.title}
                                    </Title>
                                    <Space className='pt-1' align='end'>
                                        <img src='/assets/icons/mail.png' width={16} />
                                        <NavLink to='/'>
                                            <Text className='hovera'>
                                                {con?.desc}
                                            </Text>
                                        </NavLink>
                                    </Space>
                                </Flex>
                                )
                            }
                        </Space>
                        {
                            items?.heading === 'CONTACT' &&
                            <Flex className='pl-40 mt-3' gap={10}>
                                <Link to='/' target="_blank">
                                    <Image src='/assets/icons/twitter.png' width={'23px'} preview={false} />
                                </Link>
                                <Link to='/' target="_blank" >
                                    <Image src='/assets/icons/facebook.png' width={'23px'} preview={false} />
                                </Link>
                                <Link to='/' target="_blank">
                                    <Image src='/assets/icons/linkedin.png' width={'23px'} preview={false} />
                                </Link>
                                <Link to='/' target="_blank" >
                                    <Image src='/assets/icons/insta.png' width={'23px'} preview={false} />
                                </Link>
                            </Flex>
                        }
                    </Col>
                    )
                }
                <Col span={24}>
                    <Divider className='my-2 ' style={{borderColor:'#000'}} />
                    <Flex justify='center' wrap  className='width-100 pt-2' gap={20}>
                        <Typography.Text className='fs-13'>
                            {/* Mozeff Web3 Incubator All right reserved. © 2025 */}
                            Copyright © 2025 <NavLink to={'https://replatechnologies.com/'} target='_blank' className=''><Text>REPLA Technologies Pvt Ltd</Text></NavLink>
                        </Typography.Text>
                    </Flex>
                </Col>
            </Row>
        </div>
    </div>
  )
}

export {Footer}